import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './styles/global.css';
import GlobalStyles from './styles/GlobalStyles';
// Temporairement désactiver le service worker qui pourrait causer des problèmes
// import { registerServiceWorker } from './serviceWorkerRegistration';

/**
 * Script de diagnostic pour TaxiMoove
 * Commenté pour voir le site sans diagnostic
 */
function runDiagnostics() {
  console.log('🔍 Démarrage des diagnostics TaxiMoove...');
  
  // Vérifier l'environnement
  console.log('📊 Environnement:', {
    url: window.location.href,
    userAgent: navigator.userAgent,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    hasServiceWorker: 'serviceWorker' in navigator
  });

  // Vérifier les problèmes d'importation
  try {
    const ReactCheck = typeof React !== 'undefined';
    const ReactDOMCheck = typeof ReactDOM !== 'undefined';
    console.log('📦 Vérification des modules React:', {
      hasReact: ReactCheck,
      hasDOM: ReactDOMCheck
    });
  } catch (e) {
    console.error('❌ Erreur lors de la vérification des modules:', e);
  }

  // Vérifier le DOM
  setTimeout(() => {
    console.log('🌳 État du DOM:', {
      hasRootElement: !!document.getElementById('root'),
      bodyChildren: document.body.children.length,
      visibleContent: document.body.innerHTML.length > 100
    });
  }, 1000);

  // Intercepter les erreurs futures
  window.addEventListener('error', (event) => {
    console.error('🚨 Erreur globale interceptée:', event.error);
  });

  console.log('✅ Diagnostics initiaux terminés');
}

// Exécuter les diagnostics avant le rendu
// Commenté pour désactiver le diagnostic
// runDiagnostics();

// Désactiver temporairement le service worker
// registerServiceWorker();

// Optimiser les performances de rendu
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ Élément root non trouvé dans le DOM');
  document.body.innerHTML = '<div style="padding: 20px; text-align: center;"><h2>Erreur de chargement</h2><p>Impossible de trouver l\'élément racine.</p></div>';
} else {
  console.log('✅ Élément root trouvé');
  
  try {
    // Créer la racine React
    const root = ReactDOM.createRoot(rootElement);
    
    // Rendu de l'application
    root.render(
      <React.StrictMode>
        <BrowserRouter>
          <GlobalStyles />
          <App />
        </BrowserRouter>
      </React.StrictMode>
    );
    
    console.log('✅ Application rendue');
  } catch (error) {
    console.error('❌ Erreur lors du rendu:', error);
    rootElement.innerHTML = '<div style="padding: 20px; text-align: center;"><h2>Erreur de rendu</h2><p>Une erreur est survenue lors du chargement de l\'application.</p><pre style="text-align: left; background: #f5f5f5; padding: 10px; border-radius: 5px; overflow: auto;">' + String(error) + '</pre></div>';
  }
} 